// @ts-nocheck

import React, { useEffect, useState } from "react";
import Link from "next/link";
import styled, { css } from "styled-components";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { noop } from "lodash";

import { AircraftSelectionTablet } from "./AircraftSelectionTablet";
import { selectAuthState } from "@/stores/slices/authSlice";
import { RAImage, RAAvatar, RATypography, Flex } from "@/components/customs";
import { SvgUser, SvgClose } from "@/assets/icons";
import { IconWarningAlert } from "@/assets/images";
import { PATH_ROUTES } from "@/config/routes";
import s from "./HeaderMobile.module.css";

import { RAFavicon } from "../RAFavicon";
import { useHeaderSolid } from "@/hooks/HeaderSolidContext";
import { HamburgerMenu } from "./HamburgerMenu";
import { AircraftSelectionMobile } from "./AircraftSelectionMobile";

import { Grid } from "antd";
const { useBreakpoint } = Grid;

export const HeaderMobile = ({ userMenuOptions, onClickOpenLogin, asPath, onPressRequestQuote = noop }) => {
	const { isSolid } = useHeaderSolid();

	const { md } = useBreakpoint();

	const { pathname } = useRouter();
	const { user } = useSelector(selectAuthState);
	const [openMenu, setOpenMenu] = useState(false);
	const [openProfileMenu, setOpenProfileMenu] = useState(false);
	const [selectAircraft, setSelectAircraft] = useState(false);
	const [openService, setOpenService] = useState(false);

	useEffect(() => {
		setSelectAircraft(false);
		setOpenService(false);

		// lock scrolling whole page underneath when menus are opened
		if (openMenu || openProfileMenu) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "";
		}
	}, [openMenu, openProfileMenu]);

	return (
		<div className={s.container} data-solid-color={(isSolid || openMenu || openProfileMenu).toString()}>
			<div className={s.content}>
				<div
					className={s.favicon}
					onClick={() => {
						setSelectAircraft(false);
						setOpenProfileMenu(false);
						setOpenMenu(false);
					}}
				>
					<RAFavicon />
				</div>
				<div className={s.navbar}>
					<div className={s.navbar_hamburger}>
						<HamburgerMenu
							open={openMenu}
							onToggleMenu={() => {
								setOpenMenu((prev) => !prev);
								setOpenProfileMenu(false);
							}}
						/>
					</div>
					<Flex alignItems="center" justifyContent="center">
						{user && user._id ? (
							<div className={s.flip_card}>
								<div
									className={s.flip_card_inner}
									style={{
										transform: `${openProfileMenu ? "rotateY(180deg)" : "none"}`,
									}}
								>
									<div className={s.flip_card_front}>
										<WrapperUser>
											<RAAvatar
												size={36}
												style={{ cursor: "pointer" }}
												src={user?.avatar?.url ?? null}
												name={`${user?.first_name} ${user?.last_name}`}
												onClick={() => {
													if (openMenu) {
														setOpenMenu(false);
													}
													setOpenProfileMenu(true);
												}}
											/>
											{!user?.activated && (
												<WrapperIconAbsolute>
													<RAImage url={IconWarningAlert} width="12px" height="12px" />
												</WrapperIconAbsolute>
											)}
										</WrapperUser>
									</div>
									<div className={`${s.flip_card_back}`}>
										<SvgClose
											color="#A8A8A8"
											width={28}
											height={28}
											style={{ cursor: "pointer" }}
											onClick={() => {
												setOpenProfileMenu(false);
											}}
										/>
									</div>
								</div>
							</div>
						) : (
							<div className={s.navbar_user_icon}>
								<SvgUser
									onClick={onClickOpenLogin}
									width={32}
									height={32}
									style={{ cursor: "pointer" }}
								/>
							</div>
						)}
					</Flex>
				</div>
			</div>
			<DropDownMenu className={openMenu ? s.open_menu : s.close_to_left}>
				<MenuItem active={pathname === PATH_ROUTES.PATH_SERVICE_PRIVATE_JET_TRAVEL ? "active" : undefined}>
					<div
						style={{ cursor: "pointer" }}
						onClick={() => {
							setOpenMenu(false);
							onPressRequestQuote();
						}}
					>
						<TypographyNav
							color={pathname === PATH_ROUTES.PATH_SERVICE_PRIVATE_JET_TRAVEL ? "#222" : "#595959"}
						>
							Flight Request
						</TypographyNav>
					</div>
				</MenuItem>
				<MenuItem active={selectAircraft} onClick={() => setSelectAircraft((prev) => !prev)}>
					<div>
						{!selectAircraft ? (
							<TypographyNav color={"#595959"}>Fleet</TypographyNav>
						) : (
							<RATypography variant="sub-heading4" color={"#222222"}>
								Fleet
							</RATypography>
						)}
					</div>
				</MenuItem>
				<MenuItem active={openService} onClick={() => setOpenService((prev) => !prev)}>
					<div>
						{!openService ? (
							<TypographyNav color={"#595959"}>Services</TypographyNav>
						) : (
							<RATypography variant="sub-heading4" color={"#222222"}>
								Services
							</RATypography>
						)}
					</div>
				</MenuItem>
				<div
					style={{
						transition: "all 0.8s",
						display: openService ? "block" : "none",
					}}
				>
					<SubMenuItem
						className={`animate__animated animate__faster ${
							openService ? "animate__backInRight" : "animate__backOutRight"
						}`}
					>
						<Link href={PATH_ROUTES.PATH_SERVICE_PRIVATE_JET_TRAVEL} onClick={() => setOpenMenu(false)}>
							<TypographyNav color={"#222222"}>Private Jet Travel</TypographyNav>
						</Link>
					</SubMenuItem>
					<SubMenuItem
						className={`animate__animated ${
							openService ? "animate__backInRight" : "animate__backOutRight"
						}`}
					>
						<Link href={PATH_ROUTES.PATH_SERVICE_JET_ONE_SUITES} onClick={() => setOpenMenu(false)}>
							<TypographyNav color={"#222222"}>Jet 1 Suites</TypographyNav>
						</Link>
					</SubMenuItem>
					<SubMenuItem
						className={`animate__animated animate__fast ${
							openService ? "animate__backInRight" : "animate__backOutRight"
						}`}
					>
						<Link href={PATH_ROUTES.PATH_SERVICE_AIR_FREIGHT} onClick={() => setOpenMenu(false)}>
							<TypographyNav color={"#222222"}>Air Freight</TypographyNav>
						</Link>
					</SubMenuItem>
				</div>
				<MenuItem active={undefined}>
					<Link href={PATH_ROUTES.PATH_JOURNEY} onClick={() => setOpenMenu(false)}>
						<TypographyNav color={"#595959"}>Journey</TypographyNav>
					</Link>
				</MenuItem>
				<MenuItem active={pathname === PATH_ROUTES.PATH_CONTACT_US ? "active" : undefined}>
					<Link
						href={PATH_ROUTES.PATH_CONTACT_US}
						className={pathname === PATH_ROUTES.PATH_CONTACT_US ? "active" : undefined}
						onClick={() => setOpenMenu(false)}
					>
						<TypographyNav color={pathname === PATH_ROUTES.PATH_CONTACT_US ? "#222" : "#595959"}>
							Contact
						</TypographyNav>
					</Link>
				</MenuItem>
			</DropDownMenu>
			<DropDownProfileMenu className={openProfileMenu ? s.open_menu : s.close_to_right}>
				{userMenuOptions?.map((item, index) => {
					return (
						<MenuProfileItem
							key={index}
							onClick={() => setOpenProfileMenu(false)}
							active={asPath === item?.key}
						>
							{item.label}
						</MenuProfileItem>
					);
				})}
			</DropDownProfileMenu>
			<SelectAircraftMenu
				className={selectAircraft ? s.open_menu : s.close_to_right}
				style={{
					backgroundImage: `url(${"/images/header/aircrafts/bg.png"})`,
					backgroundSize: "cover",
				}}
			>
				{md ? (
					<AircraftSelectionTablet
						open={selectAircraft}
						onUpdateOpen={setSelectAircraft}
						onClose={() => {
							setSelectAircraft(false);
							setOpenProfileMenu(false);
							setOpenMenu(false);
						}}
					/>
				) : (
					<AircraftSelectionMobile
						open={selectAircraft}
						onUpdateOpen={setSelectAircraft}
						onClose={() => {
							setSelectAircraft(false);
							setOpenProfileMenu(false);
							setOpenMenu(false);
						}}
					/>
				)}
			</SelectAircraftMenu>
		</div>
	);
};

const TypographyNav = styled.div`
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 22px;
	text-align: left;
	letter-spacing: 0.064em;
	color: ${(props) => props.color || "#ffffff"};
`;
const DropDownMenu = styled.div`
	z-index: 10;
	margin-top: 80px;
	position: absolute;
	top: 0px;
	width: 100%;
	background: #fff;
	overflow: hidden;
	height: 100vh;
	flex-direction: column;
	transition: transform 0.8s;
`;
const SelectAircraftMenu = styled.div`
	z-index: 10;
	margin-top: 80px;
	position: absolute;
	top: 0px;
	width: 100%;
	background: #fff;
	overflow: hidden;
	flex-direction: column;
	height: calc(100vh - 80px);
	transition: transform 0.8s;
	overflow-y: auto;

	&::-webkit-scrollbar {
		display: none;
	}
`;
const DropDownProfileMenu = styled.div`
	z-index: 10;
	margin-top: 80px;
	position: absolute;
	top: 0px;
	width: 100%;
	background: #fff;
	overflow: hidden;
	flex-direction: column;
	height: 100vh;
	transition: transform 0.8s;
`;
const MenuItem = styled.div`
	padding: 24px;
	text-align: left;
	border-top: 1px solid #e9e8e8;
	cursor: pointer;
	${(props) =>
		props.active &&
		css`
			border-left: 3px solid #ffb11a;
		`}
`;
const SubMenuItem = styled.div`
	padding: 16px 16px 16px 50px;
	text-align: left;
	border-top: 1px solid #e9e8e8;
	cursor: pointer;
`;
const MenuProfileItem = styled.div`
	padding: 17px;
	border-top: 1px solid #e9e8e8;
	${(props) =>
		props.active &&
		css`
			border-left: 3px solid #ffb11a;
		`}
`;
const WrapperUser = styled.div`
	position: relative;
`;
const WrapperIconAbsolute = styled.div`
	position: absolute;
	bottom: 0px;
	right: 0px;
`;
